<template>
  <div class="row">
    <form-select
      :grid="col"
      v-model="unidade_selected"
      label="Unidades"
      :itens="unidades"
      :loading="loading"
      :disabled="loading"
      :multiple="true"
      @change="getTecnicosUnidade"
      @deselecting="removerUnidade"
      ajuda="&#9702; É necessário selecionar uma unidade para escolher o técnico<br/>&#9702; Não é possível salvar apenas a unidade. As unidades que aparecerão nesse campo são as unidades dos técnicos participantes cadastrados.</b>"
    />
    <form-select
      :grid="col"
      v-if="!loading"
      v-model="tecnicos"
      label="Técnicos participantes"
      placeholder="Selecione uma unidade acima"
      :multiple="multiple"
      :itens="tecnicos_selected"
      @change="setTecnicos"
    />
  </div>
</template>
<script>
export default {
  model: {
    prop: "tecnicos",
    event: "change",
  },
  props: {
    multiple: { type: Boolean, default: true },
    tecnicos: { type: Array, default: () => {} },
    col: { type: String, default: "12" },
  },
  data() {
    return {
      unidade_selected: [],
      tecnico_temp: [],
      all_tecnicos: [],
      tecnicos_array: [],
      unidades: [],
      tecnicos_selected: [],
      loading: false,
      loading_tecnicos: false,
    };
  },
  watch: {
    tecnicos() {
      if (
        this.tecnicos &&
        this.tecnicos.length <= 0 &&
        this.tecnico_temp.length > 0
      ) {
        this.tecnicos = this.tecnico_temp;
      }
    },
  },
  mounted() {
    this.getUnidades();
  },
  methods: {
    getUnidades() {
      this.loading = true;
      axios
        .get(`api/get/unidadeswithtecnicos`)
        .then((response) => {
          this.unidades = response.data.unidades;
          this.all_tecnicos = response.data.tecnicos;
        })
        .finally(() => {
          this.loading = false;
          if (
            this.unidade_selected &&
            this.unidade_selected.length <= 0 &&
            this.tecnicos &&
            this.tecnicos.length > 0
          ) {
            this.setUnidadeSelected(this.tecnicos);
          }
          if (this.tecnicos && this.tecnicos.length > 0) {
            this.listTecnicosSelected(false);
            this.getTecnicosUnidade();
          }
        });
    },
    setTecnicoParticipante() {
      if (this.tecnicos == null) {
        this.tecnicos = [this.tecnico_temp];
      } else {
        this.tecnicos.push(this.tecnico_temp);
      }
      this.$refs.selecttecnico.item = null;
      this.listTecnicosSelected();
    },
    getTecnicosUnidade() {
      this.tecnicos_selected = [];
      this.tecnicos_array = [];
      if (
        Array.isArray(this.unidade_selected) &&
        this.unidade_selected.length > 0
      ) {
        let unidade = this.unidade_selected.map((u) => {
          let temp = this.unidades.filter((item) => {
            return item.id == u;
          });
          return temp[0];
        });

        unidade.forEach((item) => {
          item.tecnicos.forEach((tecnico) => {
            this.tecnicos_array.push(tecnico);
            this.tecnicos_selected.push(tecnico);
          });
        });

        this.verificarTecnicosSelecionados();
      }
    },
    removerUnidade() {
      console.log("teste remove");
    },
    setTecnicos() {
      this.tecnico_temp = this.tecnicos;
      this.$emit("update:tecnicos", this.tecnicos);
    },
    setUnidadeSelected(tecnicos) {
      let unidades = [];
      tecnicos.map((elem) => {
        let temp = this.all_tecnicos.find((item) => {
          return item.id == elem;
        });

        if (temp && unidades.indexOf(temp.id_unidade) < 0) {
          unidades.push(temp.id_unidade);
        }
      });
      this.unidade_selected = unidades;
    },
    verificarTecnicosSelecionados() {
      //Verificar se dos técnicos selecionados não existe o respectivo na listagem de tecnicos_selected
      /*É necessário que percorra a lista de todos os técnicos pegue as informações do técnico que está com o id
       * no array tecnicos, e antes de inserir na lista de tecnicos_selected, verificar se o técnico já não está na lista
       */
      let tecnicos = this.getTecnicosArray();

      if (this.tecnicos_selected.length > 0 && tecnicos.length > 0) {
        let tecnico_not_include = [];
        let tecnico_include = [];

        this.tecnicos_selected.forEach((tecnico) => {
          let temp = this.tecnicos.filter((item) => {
            return item == tecnico.id;
          });
          if (temp.length > 0) {
            tecnico_include.push(temp[0]);
          }
        });
        this.tecnicos = tecnico_include;

        this.$emit("update:tecnicos", this.tecnicos);
      }
    },
    getTecnicosArray() {
      let tecnicos = [];
      this.tecnicos.map((elem) => {
        let temp = this.all_tecnicos.find((item) => {
          return item.id == elem;
        });

        if (temp) {
          tecnicos.push({
            id: temp.id,
            value: " <b>" + temp.value + "</b> - " + temp.nome_unidade,
          });
        }
      });
      return tecnicos;
    },
    listTecnicosSelected(verify = true, set_all = false) {
      if (this.tecnicos_array.length > 0 || verify == false) {
        let tecnicos = this.getTecnicosArray();

        if (set_all) {
          return tecnicos;
        }
        if (verify == false) {
          this.tecnicos_selected = tecnicos.length > 0 ? tecnicos : [];
        }
      }
      // this.tecnico_temp = null;
    },
  },
};
</script>
